import React from "react";
import { Link } from "react-router-dom";
import { withTranslation } from "react-i18next";

class NotFound extends React.Component {
  render() {
    const { t } = this.props;
    return (
      <div className="container mt-4">
        <div className="spare-dvs vh-100 align-items-start">
          <div className="w-100 float-left">
            <h1>{t('notFound:title')}</h1>
            <div className="log-form">
              <Link to="/login" className="log-btn">
                {t('notFound:goHome')}
              </Link>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withTranslation(['notFound'])(NotFound);
